export enum OverflowState {
  NONE = 'NONE',
  SCROLL = 'SCROLL',
  PAGING = 'PAGING',
  STEADY_SCROLL = 'STEADY_SCROLL',
  SECTION_SCROLL = 'SECTION_SCROLL',
  SECTION_PAGING = 'SECTION_PAGING',
  SECTION_PAGING_HIDDEN = 'SECTION_PAGING_HIDDEN'
}
